const columns = [
  {
    title: '内容分区',
    links: [
      { label: '今日吃瓜热点', href: '#hot' },
      { label: '现场爆料合集', href: '#onsite' },
      { label: '新料速递条', href: '#ticker' },
      { label: '吃瓜指南', href: '#guide' },
    ],
  },
  {
    title: '围观入口',
    links: [
      { label: '关注速递', href: '#subscribe' },
      { label: '常见疑问', href: '#faq' },
      { label: '更新说明', href: '#faq' },
      { label: '免责声明', href: '#disclaimer' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-alarm-warning-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">黑料51</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-200">
              黑料51 是一个以速递为主的吃瓜资讯聚合页，把当天的吃瓜热点、现场爆料和围观入口收在同一个首页里，
              按时间往下滚就能把线索串起来。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-primary-200">
                <i className="ri-radar-line" />
              </span>
              <span className="text-sm text-primary-200">速递条持续滚动更新，无需注册即可浏览</span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                <a href="#top" className="cursor-pointer hover:text-accent-300">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3" id="disclaimer">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <a href="#faq" className="cursor-pointer hover:text-accent-300">
                免责说明
              </a>
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              本站内容整理自公开流传的信息，仅作时间线汇总与浏览参考，不构成对任何个人或事件的判断。
              如涉及权益问题，请以相关当事方的公开说明为准。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-300">© 2026 黑料51 · 吃瓜资讯聚合页</p>
          <p className="text-xs text-primary-300">本站为静态展示页面，按钮与输入框不连接任何接口</p>
        </div>
      </div>
    </footer>
  );
}